import { Skeleton } from '@/components/ui/skeleton'
import { CustomerActionCard } from '@/features/purchase-orders/actions'
import { ActionItemSourceProvider } from '@/features/purchase-orders/action-source'
import { ACTION_FOCUS_CLASS, actionTargetProps } from '@/hooks/use-action-focus'
import { cn } from '@/lib/utils'
import { useManufacturerDataAction } from './hooks'
import { toPurchaseOrderAction } from './model'

/** Data items about a whole mailbox rather than a manufacturer (USA-1729). */
export const SENDER_BLOCKED = 'mail_sender_blocked'

/**
 * A mailbox our own mail system refuses (USA-1729), as its action card: what refused it, how to fix it, and
 * "It's fixed, send again". No manufacturer page holds it, so it is shown where it is listed.
 */
export function MailboxBlockItem({ actionId, bordered = true }: { actionId: number; bordered?: boolean }) {
  const item = useManufacturerDataAction(actionId)
  const action = item.data ? toPurchaseOrderAction(item.data) : null
  if (item.isLoading) return <Skeleton className="h-32 w-full" />
  if (!action) {
    return <p className="text-sm text-muted-foreground">This item could not be loaded. Try again shortly.</p>
  }
  return (
    <ActionItemSourceProvider value={{ kind: 'manufacturer_data', manufacturerUuid: '' }}>
      <div
        {...actionTargetProps(action.uuid)}
        className={cn(bordered && 'rounded-xl border bg-card p-4', ACTION_FOCUS_CLASS)}
      >
        <CustomerActionCard action={action} reopens={[]} />
      </div>
    </ActionItemSourceProvider>
  )
}
